import {
  AsYouType,
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumberFromString,
} from 'libphonenumber-js/min'

/** Mismos países y orden que la app móvil. */
const COUNTRY_LABELS = [
  ['US', 'Estados Unidos'],
  ['MX', 'México'],
  ['GT', 'Guatemala'],
  ['SV', 'El Salvador'],
  ['HN', 'Honduras'],
  ['NI', 'Nicaragua'],
  ['CR', 'Costa Rica'],
  ['PA', 'Panamá'],
  ['CO', 'Colombia'],
  ['VE', 'Venezuela'],
  ['EC', 'Ecuador'],
  ['PE', 'Perú'],
  ['DO', 'República Dominicana'],
  ['PR', 'Puerto Rico'],
  ['CU', 'Cuba'],
  ['AR', 'Argentina'],
  ['CL', 'Chile'],
  ['ES', 'España'],
]

export const DEFAULT_PHONE_COUNTRY = 'US'

export const PHONE_COUNTRIES = COUNTRY_LABELS.map(([code, label]) => ({
  code,
  label,
  dialCode: `+${getCountryCallingCode(code)}`,
}))

export function phoneCountryLabel(code) {
  const option = PHONE_COUNTRIES.find((item) => item.code === code)
  return option ? `${option.code} ${option.dialCode}` : code
}

export function formatPhoneAsYouType(raw, country) {
  return new AsYouType(country).input(String(raw || ''))
}

export function detectPhoneCountry(raw, fallback) {
  const value = String(raw || '').trim()
  if (!value.startsWith('+')) return fallback
  const typer = new AsYouType()
  typer.input(value)
  return typer.getCountry() || fallback
}

export function isValidPhone(raw, country) {
  const value = String(raw || '').trim()
  if (!value) return false
  return isValidPhoneNumber(value, country)
}

/**
 * Formato que espera el backend, igual que la app: nacional en EE. UU. e internacional en otros países.
 * @throws {Error} si el número no es válido
 */
export function toBackendPhone(raw, country) {
  const parsed = parsePhoneNumberFromString(String(raw || '').trim(), country)
  if (!parsed || !parsed.isValid()) {
    throw new Error('Invalid phone number')
  }
  return parsed.country === 'US' ? parsed.formatNational() : parsed.formatInternational()
}
